import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { Error404Component } from './error404/error404.component';

import { SharedModule } from '@shared';

@NgModule({
  declarations: [Error404Component],
  imports: [CommonModule, SharedModule, ReactiveFormsModule],
})
export class HomeModule {
}
